import { UserStatus } from './user-status.enum';

export class UpdateRegisteredUserRequest {
  constructor(
    public status: UserStatus,
    public resourceId: string,
    public username: string,
    public email: string,
    public additionalUsernames: string[],
    public disableNotifications: boolean
  ) {}

  customerId: string | null = null;
  userId: string | null = null;
}
